import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import Price from '../Price/Price.js';

const priceBaseClassName = 'elements-line-item-aside__price';
const LineItemAside = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { children , className , currency , discountPrice , price  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className",
        "currency",
        "discountPrice",
        "price"
    ]);
    const { getLabel  } = useIntl();
    let content = children;
    if (discountPrice === 0) {
        content = /*#__PURE__*/ React.createElement("p", {
            className: `${priceBaseClassName} ${priceBaseClassName}--free`
        }, /*#__PURE__*/ React.createElement("span", {
            className: "price"
        }, getLabel('products.freeProduct')));
    } else if (!children && price) {
        const classNames = classnames(priceBaseClassName, {
            [`${priceBaseClassName}--strikethrough`]: typeof discountPrice === 'number'
        });
        content = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", {
            className: classNames
        }, /*#__PURE__*/ React.createElement(Price, {
            value: price,
            currency: currency
        })), discountPrice && /*#__PURE__*/ React.createElement(React.Fragment, null, "\xa0", /*#__PURE__*/ React.createElement("p", {
            className: priceBaseClassName
        }, /*#__PURE__*/ React.createElement(Price, {
            value: discountPrice,
            currency: currency,
            type: "discount"
        }))));
    }
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('elements-line-item-aside', className),
        ref: ref
    }), content);
});
LineItemAside.displayName = 'LineItemAside';

export { LineItemAside as default };
//# sourceMappingURL=LineItemAside.js.map
